import React from 'react';
import {
  AccountCentralizedInfo,
  AccountInfoResult,
  TransactorHashType,
} from '@block-explorer/entities';
import {
  HashFontSize,
  TableDataAccountInfo,
} from '../table-data-account-info/table-data-account-info';
import { FlexRowProps, HashLength, Size } from '@make-software/cspr-design';
import { deriveAccountInfo } from '../../utils/account';
import { AvatarProps } from '../avatar/avatar';
import { ContractIdentifierWithApi } from '../contract-identifier/contract-identifier';

interface TransactorInfoProps {
  type?: TransactorHashType | undefined;
  accountInfo: AccountInfoResult | AccountCentralizedInfo | undefined;
  hash: string | null;
  publicKey: string | null;
  csprName?: string | null;
  loading: boolean;
  hashLength?: HashLength;
  hashFontSize?: HashFontSize;
  copyNotifyingStyle?: 'full' | 'tiny';
  avatarSize?: AvatarProps['size'];
  nameSize?: Size;
  withName?: boolean;
  horizontalAlign?: FlexRowProps['align'];
}
// TODO: MOVE TO LIB
export const TransactorInfo = ({
  type,
  accountInfo,
  publicKey,
  hash,
  csprName,
  loading,
  hashLength,
  hashFontSize = HashFontSize.default,
  copyNotifyingStyle,
  avatarSize = 'default',
  nameSize,
  withName = false,
  horizontalAlign,
}: TransactorInfoProps) => {
  const accountInfoResult = deriveAccountInfo(accountInfo);

  return type && type === TransactorHashType.hash ? (
    <ContractIdentifierWithApi
      hash={hash}
      hashLength={hashLength}
      hashFontSize={hashFontSize}
      avatarSize={avatarSize}
      loading={loading}
      hideContractType
      withName={withName}
    />
  ) : (
    <TableDataAccountInfo
      logo={accountInfoResult && accountInfoResult?.logo}
      name={accountInfoResult?.name}
      publicKey={publicKey || hash}
      csprName={csprName || undefined}
      loading={loading}
      hashLength={hashLength}
      hashFontSize={hashFontSize}
      copyNotifyingStyle={copyNotifyingStyle}
      avatarSize={avatarSize}
      nameSize={nameSize}
      horizontalAlign={horizontalAlign}
    />
  );
};

export default TransactorInfo;
